import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { environment } from '../environments/environment';
import { MainNavComponent } from './main-nav/main-nav.component';
import { MarketComponent } from './market/market.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { ShopDetailsComponent } from './shop-details/shop-details.component';
import { MapComponent } from './map/map.component';
import { CovidPartnersComponent } from './covid-partners/covid-partners.component';

const routes: Routes = [
  // { path: 'stickers/:id', component: StickersDetailComponent },
  // { path: 'deliveries/:id', component: DeliveriesDetailComponent },
  { path: 'empty', component: PageNotFoundComponent },
  // { path: 'markets/:id', component: MarketComponent },
  // { path: 'shops/:id', component: ShopDetailsComponent },
  {
    path: '',
    component: MainNavComponent,
    children: [
      {
        path: 'markets/:id',
        component: MarketComponent, pathMatch: 'full'
      },
      {
        path: 'map',
        component: MapComponent
      },
      {
        path: 'covid-partners',
        component: CovidPartnersComponent
      },
      {
        path: '',
        redirectTo: 'map',
        pathMatch: 'full'
      }
    ]
  },
  // {
  //   path: '',
  //   redirectTo: '/',
  //   pathMatch: 'full'
  // },
  { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: !environment.production })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
